/**
 * Created by jiayanfeng on 2018/3/9.
 */


import {Portal_Page_Content, Portal_Page_Reset_Content} from "./PortalConstants";
import {combineReducers} from "redux";

const initContent = {
  enterpriseId:"",
  adCarousel:true,
  affix:false,
  companions:false,
  footer:true,
  header:true,
  market:true,
  rapidReg:false,
  news:true,
  services:true,
  solutions:true,
};

function content(state = {...initContent}, action) {
  switch(action.type) {
    case Portal_Page_Content:
      return action.data;
    case Portal_Page_Reset_Content:
      return {...initContent};
    default:
      return state;
  }
}

function isLoading(state=true,action){
  switch (action.type){
    case Portal_Page_Content:
      return false;
    case Portal_Page_Reset_Content:
      return true;
    default:
      return state;
  }
}
// function headerContent(state = null, action) {
//   switch(action.type) {
//     case Portal_Page_Header:
//       return action.data;
//     default:
//       return state;
//   }
// }
//
// function redirectItems(state = [], action) {
//   switch(action.type) {
//     case Portal_Page_Redirect_Item:
//       return action.data;
//     default:
//       return state;
//   }
// }
//
// function advertisements(state = [], action) {
//   switch(action.type) {
//     case Portal_Page_Redirect_Item:
//       return action.data;
//     default:
//       return state;
//   }
// }
// function rapidRegs(state = null, action) {
//   switch(action.type) {
//     case null:
//       return action.data;
//     default:
//       return state;
//   }
// }

const portalPageReducer = combineReducers({content,isLoading,}
  // headerContent,advertisements,redirectItems,
  // rapidRegs}
  );
export default  portalPageReducer;
